export const getDistinctModulesBasedOnVisible = (meta) => {
    if (!meta || meta.length === 0) {
        return null;
    }
    const set = {};
    meta.forEach(element => {
        if (!set[element.id] && element.visible === true){
            set[element.id] = element;
        }
    });
    return Object.values(set);
}

export const getDistinctModules = (meta) => {
    if (!meta || meta.length === 0) {
        return null;
    }
    const set = {};
    meta.forEach(element => {
        if (!set[element.id]){
            set[element.id] = element;
        }
    });
    return Object.values(set);
}